<template>
  <div class="homepage">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container">
        <div class="brand">广东广福宏宇保险经纪有限公司</div>

        <!-- 桌面菜单 -->
        <ul class="desktop-menu" v-if="!isMobile">
          <router-link
            to="/orderList"
            @click="showMobileMenu=false"
            :class="{ active: $route.name === 'orderList' }"
          >
            订单中心
          </router-link>
        </ul>

        <!-- 移动端菜单按钮 -->
        <button
          class="mobile-menu-btn"
          v-if="isMobile"
          @click="showMobileMenu=!showMobileMenu"
        >☰</button>

        <!-- 移动端展开菜单 -->
        <ul class="mobile-menu" v-show="showMobileMenu">
          <li><a href="#" @click="showLoginModal=true;showMobileMenu=false">订单中心</a></li>
        </ul>
      </div>
    </nav>
    <br/>
    <!-- 在导航栏和页脚之间添加 -->
    <main class="order-main container">
      <!-- 查询条件 -->
      <div class="search-box">
        <span  v-if="!$route.query.saleId">销售单号</span>
        <el-input
          v-if="!$route.query.saleId"
          v-model="searchOrderId"
          placeholder="输入销售单号查询"
          style="width: 240px; margin-right: 15px"
          @keyup.enter="fetchOrders"
        ></el-input>

        付款状态：
        <el-select
          v-model="selectedStatus"
          placeholder="选择付款状态"
          style="width: 180px"
        >
          <el-option style="text-align: center;" label="全部" value=""></el-option>
          <el-option style="text-align: center;" label="待付款" value="0"></el-option>
          <el-option style="text-align: center;" label="已支付" value="1"></el-option>
          <el-option style="text-align: center;" label="已取消" value="2"></el-option>
        </el-select>

        订单状态：
        <el-select
          v-model="selectedOrderStatus"
          placeholder="选择订单状态"
          style="width: 180px; margin-right: 15px"
        >
          <el-option style="text-align: center;" label="全部" value=""></el-option>
          <el-option style="text-align: center;" label="未提交" value="0"></el-option>
          <el-option style="text-align: center;" label="已提交" value="1"></el-option>
          <el-option style="text-align: center;" label="已审核" value="2"></el-option>
          <el-option style="text-align: center;" label="已完成" value="3"></el-option>
          <el-option style="text-align: center;" label="已作废" value="4"></el-option>
          <el-option style="text-align: center;" label="已退费" value="5"></el-option>
        </el-select>

        <el-button
          type="primary"
          class="search-btn"
          @click="fetchOrders"
        >
          搜索
        </el-button>
      </div>

      <!-- 订单表格 -->
      <el-table :data="orderList" style="width: 100%; margin-top: 40px">
        <el-table-column label="序号" width="80" align="center">
          <template #default="{ $index }">{{ $index + 1 }}</template>
        </el-table-column>
        <el-table-column label="销售单号" prop="saleId" min-width="180"></el-table-column>
        <el-table-column label="投保人" prop="appliName" min-width="120"></el-table-column>
        <el-table-column label="被保人" prop="insuredName" min-width="120"></el-table-column>
        <!-- 金额相关列 -->
        <el-table-column label="付款金额" width="120" align="right">
          <template #default="{ row }">¥{{ row.paymentAmount }}</template>
        </el-table-column>
        <el-table-column label="剩余金额" width="120" align="right">
          <template #default="{ row }">¥{{ row.remainingAmount || '0.00' }}</template>
        </el-table-column>
        <el-table-column label="已退金额" width="120" align="right">
          <template #default="{ row }">¥{{ row.refundAmount || '0.00' }}</template>
        </el-table-column>
        <!-- 状态列 -->
        <el-table-column label="付款状态" width="100" align="center">
          <template #default="{ row }">
            <el-tag :type="paymentStatusTag(row.paymentStatus)" size="small">
              {{ paymentStatusText(row.paymentStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" width="100" align="center">
          <template #default="{ row }">
            <el-tag :type="orderStatusTag(row.orderStatus)" size="small">
              {{ orderStatusText(row.orderStatus) }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 时间列 -->
        <el-table-column label="创建时间" width="160" prop="createTime"></el-table-column>

        <el-table-column label="操作" width="150" align="center">
          <template #default="{ row }">
            <el-dropdown placement="bottom" trigger="click">
              <el-link type="primary" :underline="true">操作</el-link>
              <el-dropdown-menu class="operation-menu">
                <el-dropdown-item v-if="row.paymentStatus == 1">
                  <el-link type="primary" @click="editOrder(row)">账单</el-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-link type="primary" @click="showDeviceDetail(row)">设备详情</el-link>
                </el-dropdown-item>
                <el-dropdown-item v-if="row.isAdvancePayment === 0 && row.isAdvancePayment != 1 && row.paymentStatus != 1" @click="payOrder(row)">
                  <el-link type="primary">付款</el-link>
                </el-dropdown-item>
                <el-dropdown-item v-if="row.isAdvancePayment === '1' && row.paymentStatus === '1'  && row.orderStatus === '0'">
                  <el-link type="primary" @click="handlePlaceOrder(row)">下单</el-link>
                </el-dropdown-item>
                <el-dropdown-item v-if="row.isAdvancePayment === '1'  && row.orderStatus != '5'  && row.orderStatus != '4'" @click="cancelOrder(row)">
                  <el-link type="primary">退费</el-link>
                </el-dropdown-item>
                <el-dropdown-item v-if="row.isAdvancePayment === '1'  && row.orderStatus != '5'  && row.orderStatus != '4'"  @click="cancelOrder(row)">
                  <el-link type="primary">作废</el-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-model="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="fetchOrders"
        style="margin-top: 20px"
      ></el-pagination>
    </main>

    <br/>
    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>© 2025 广东广福宏宇保险经纪有限公司 粤ICP备2025485413号-1 服务及投诉电话：400-867-5672</p>
        <div class="footer-links">
          <a href="#about">关于我们</a>
          <a href="#contact">联系我们</a>
          <a href="#">隐私政策</a>
        </div>
      </div>
    </footer>

    <!-- 账单弹窗 -->
    <bill-dialog
      :sale-id="selectedSaleId"
      :visible.sync="showBillDialog"
    />
    <!-- 设备详情弹窗 -->
    <device-detail-dialog
      :visible="deviceDialogVisible"
      :sale-id="currentSaleId"
    />
    <!-- 返回顶部按钮 -->
    <button
      class="back-to-top"
      v-show="showBackToTop"
      @click="scrollToTop"
    >↑</button>
  </div>
</template>
<script>
import {service} from '../../utils/axios'
import BillDialog from './components/BillDialog'
import DeviceDetailDialog from './components/DeviceDetailDialog'
export default {
  name: 'Homepage',
  components: {
    BillDialog,
    DeviceDetailDialog
  },
  data () {
    return {
      // 数据...
      // 账单弹窗状态
      showBillDialog: false,
      selectedSaleId: '',
      deviceDialogVisible: false,
      currentSaleId: null,
      isMobile: false, // 移动端判断
      showMobileMenu: false, // 移动端菜单显示状态
      showLoginModal: false, // 登录模态框显示状态
      showBackToTop: false, // 返回顶部按钮显示状态
      // ...其他数据...
      searchOrderId: '', // 订单号查询
      selectedStatus: '', // ■状态筛选
      selectedOrderStatus: '', // 订单状态筛选
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      total: 50, // 总条数
      orderList: [ // 模拟数据
        // 更多模拟数据...
      ]
    }
  },
  mounted () {
    // 初始化移动端判断
    this.isMobile = window.innerWidth <= 768
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
    this.fetchOrders()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 状态显示转换
    statusText (status) {
      return ['待付款', '已支付', '已取消'][status] || '未知状态'
    },
    // 状态标签样式
    statusTagType (status) {
      return ['warning', 'success', 'info'][status] || ''
    },

    paymentStatusText (status) {
      return ['未支付', '已支付', '支付失败'][status] || '未知'
    },
    orderStatusText (status) {
      return ['未提交', '已提交', '已审核', '已完成', '作废', '已退款'][status] || '未知'
    },
    paymentStatusTag (status) {
      return ['warning', 'success', 'danger'][status] || ''
    },
    orderStatusTag (status) {
      return ['info', '', 'success', '', 'danger', ''][status] || ''
    },
    // 操作方法
    editOrder (row) {
      console.log('账单', 111)
      this.selectedSaleId = row.id
      this.showBillDialog = true
    },
    viewDetail (row) {
      console.log('查看详情', row)
    },
    payOrder (row) {
      console.log('发起支付', row)
    },
    cancelOrder (row) {
      console.log('作废订单', row)
    },
    refundOrder (row) {
      console.log('发起退费', row)
    },
    showDeviceDetail (row) {
      this.currentSaleId = row.id
      this.deviceDialogVisible = true
    },
    handlePlaceOrder (row) {
      console.log('处理下单', row)
      this.$router.push({
        path: '/lccInsureOrder',
        query: { id: row.id }
      })
      // 这里可以添加跳转到下单页面的逻辑
      // 示例：this.$router.push(`/place-order/${row.orderNo}`);
    },
    // 获取订单数据方法（需要对接接口）
    async fetchOrders () {
      // TODO: 对接后端接口
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          saleId: this.$route.query.saleId || this.searchOrderId,
          orderStatus: this.selectedOrderStatus,
          paymentStatus: this.selectedStatus
        }

        const res = await service.get('/website/lccApplication/page', { params })
        if (res.success) {
          console.log(res.result)
          this.orderList = res.result.records
          this.total = res.result.total
          console.log(this.orderList)
        } else {
          this.$message.error('数据获取失败')
        }
      } catch (error) {
        console.error('接口请求异常:', error)
        this.$message.error('数据加载失败')
      }
    },
    // 方法...
    // 窗口大小变化处理
    handleResize () {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) this.showMobileMenu = false
    },
    // 滚动事件处理
    handleScroll () {
      this.showBackToTop = window.scrollY > 300
    },
    // 返回顶部
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}

</script>

<style scoped>
/* 搜索按钮样式 */
.search-btn {
  margin-left: 15px;
  padding: 12px 24px;
  font-size: 14px;
  border-radius: 4px;
}
/* 新增/修改样式 */
.homepage {
  display: flex;          /* 启用Flex布局 */
  flex-direction: column; /* 垂直排列子元素 */
  min-height: 100vh;      /* 至少占满整个视口高度 */
}

.product-main {
  flex: 1;                /* 内容区域自动扩展占据剩余空间 */
}
/* 页脚 */
.footer {
  background: #2c3e50;
  color: #fff;
  padding: 40px 0;
  text-align: center;
  margin-top: auto;       /* 页脚自动靠底部 */
}

.footer-links {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  justify-content: center;
}

.footer-links a {
  color: #fff;
  text-decoration: none;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #3498db;
  color: #fff;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.back-to-top:hover {
  opacity: 1;
}
/* 基础样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
/* 移动端适配 */
@media (max-width: 768px) {
  .search-btn {
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
  }
  .desktop-menu {
    display: none;
  }

  .hero {
    height: 60vh;
    margin-top: 60px;
  }

  .section {
    padding: 50px 0;
  }
}
/* 新增样式 */
/* 导航栏选中状态 */
.desktop-menu .active a,
.mobile-menu .active a {
  color: #3498db;
  font-weight: bold;
  position: relative;
}

.desktop-menu .active a::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #3498db;
}
/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand {
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.desktop-menu {
  display: flex;
  gap: 30px;
}

.desktop-menu li a, .mobile-menu li a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
}

.desktop-menu li a:hover {
  color: #3498db;
}

.mobile-menu-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
}
/** 表格*/
.operation-menu {
  text-align: center;
  min-width: 100px;
}
.el-dropdown-menu__item {
  padding: 5px 20px;
}
.el-link {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/lcc/orderList.vue